<template>
  <div id="footer">
    <div>
      <span :title="version.concat(' - ').concat(buildtime)">©</span>
      {{ new Date().getFullYear() }} —
      <strong>Alerce</strong>
    </div>
  </div>
</template>

<style>
#footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #00407d;
  height: 2em;
  color: #fff;
  display: table;
  padding: 0.1em 0 0.1em 0;
  font-size: 0.8em;
  text-align: center;
  z-index: 1000;
}

#footer > div {
  display: table-cell;
  vertical-align: middle;
}

@media screen and (max-width: 1000px) {
  #footer {
    height: 1em;
    padding: 0.1em 0 0.1em 0;
    font-size: 1em;
  }
}
</style>

<script>
export default {
  name: "RwFooter",
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    buildtime: document.documentElement.dataset.buildTimestampUtc
  })
};
</script>
